import { assertNever, ONE_MINUTE_IN_MILLIS } from '@wix/seo-common-core';
import { produce } from 'immer';
import { atom } from 'jotai';
import { panelStateAtom } from '../../atoms/session-atoms';
import { AnalysisState } from '../rules-state/use-panel-atom-state-types';
const DEFAULT_ANALYSIS_TIMEOUT_MS = 3 * ONE_MINUTE_IN_MILLIS;
const pageScanTimeoutReducer = (get, set, action) => {
  const map = get(timeoutsMapAtom);
  const newMap = new Map(map);
  const clearAndRemovePageTimeout = pageId => {
    const {
      timeout
    } = newMap.get(pageId) ?? {};
    if (timeout) {
      clearTimeout(timeout);
    }
    newMap.delete(pageId);
  };
  const createTimeoutObject = (pageId, expiresAt) => {
    return {
      expiresAt: expiresAt ?? Date.now() + DEFAULT_ANALYSIS_TIMEOUT_MS,
      timeout: setTimeout(() => {
        set(handleTimeoutExpiredAtom, pageId);
      }, expiresAt ? expiresAt - Date.now() : DEFAULT_ANALYSIS_TIMEOUT_MS)
    };
  };
  const getPageIdsByItemType = itemType => {
    return [...get(panelStateAtom).groupsDataMap.values()].filter(groupData => groupData.itemType === itemType).map(groupData => groupData.pageId);
  };
  switch (action.type) {
    case 'set':
      {
        clearAndRemovePageTimeout(action.pageId);
        newMap.set(action.pageId, createTimeoutObject(action.pageId));
        break;
      }
    case 'clear':
      {
        clearAndRemovePageTimeout(action.pageId);
        break;
      }
    case 'clear-all':
      {
        action.callback == null || action.callback(get(expiresAtMapAtom));
        [...newMap.keys()].forEach(clearAndRemovePageTimeout);
        break;
      }
    case 'clear-all-item-type':
      {
        const pageIds = getPageIdsByItemType(action.itemType);
        pageIds.forEach(clearAndRemovePageTimeout);
        break;
      }
    case 'set-all-item-type':
      {
        const pageIds = getPageIdsByItemType(action.itemType);
        pageIds.forEach(pageId => {
          clearAndRemovePageTimeout(pageId);
          newMap.set(pageId, createTimeoutObject(pageId));
        });
        break;
      }
    case 'init':
      {
        newMap.clear();
        action.expiresAtMap.forEach((expiresAt, pageId) => {
          if (expiresAt <= Date.now()) {
            set(handleTimeoutExpiredAtom, pageId);
          } else {
            newMap.set(pageId, createTimeoutObject(pageId, expiresAt));
          }
        });
        break;
      }
    default:
      {
        assertNever(action);
      }
  }
  set(timeoutsMapAtom, newMap);
};
const handleTimeoutExpired = (_, set, pageId) => {
  set(scanTimeoutReducerAtom, {
    pageId,
    type: 'clear'
  });
  set(panelStateAtom, prev => produce(prev, draft => {
    const groupData = draft.groupsDataMap.get(pageId);
    if (groupData) {
      groupData.analysisState = AnalysisState.AnalyzeFailed;
    }
  }));
};
export const timeoutsMapAtom = atom(new Map());
export const expiresAtMapAtom = atom(get => {
  return new Map([...get(timeoutsMapAtom).entries()].map(_ref => {
    let [pageId, {
      expiresAt
    }] = _ref;
    return [pageId, expiresAt];
  }));
});
export const handleTimeoutExpiredAtom = atom(null, handleTimeoutExpired);
export const scanTimeoutReducerAtom = atom(null, pageScanTimeoutReducer);
//# sourceMappingURL=atoms.js.map